export default class Theme {
    
    color1 = null
    color2 = null
    id = null

    constructor(id, color1, color2) {
        this.color1 = color1
        this.color2 = color2
        this.id     = id
    }
}